import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { db } from './firebase';
import { collection, addDoc } from 'firebase/firestore';

const SimpleCreateTrip = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState('');
  const [operationController, setOperationController] = useState(null);

  const cancelOperation = () => {
    if (operationController) {
      clearTimeout(operationController);
    }
    setLoading(false);
    setResult('❌ Operation cancelled by user');
  };

  const createSimpleTrip = async () => {
    setLoading(true);
    setResult('');
    
    // Add timeout to prevent infinite loading
    const timeout = setTimeout(() => {
      setResult('❌ Timeout: Operation taking too long. Check console for errors.');
      setLoading(false);
    }, 10000); // 10 second timeout
    
    setOperationController(timeout);
    
    try {
      console.log('🔥 Starting simple trip creation...');
      console.log('Current user:', currentUser);
      
      if (!currentUser) {
        throw new Error('No user logged in');
      }

      const tripData = {
        name: 'Test Trip ' + Date.now(),
        description: 'This is a test trip',
        currency: 'USD',
        members: [currentUser.email, 'test@example.com'],
        createdBy: currentUser.email,
        totalSpent: 0
      };

      console.log('📝 Trip data:', tripData);

      // Direct Firestore write
      const docRef = await addDoc(collection(db, 'trips'), {
        ...tripData,
        createdAt: new Date(),
        updatedAt: new Date()
      });

      clearTimeout(timeout);
      console.log('✅ Success! Trip ID:', docRef.id);
      setResult(`✅ Success! Trip created with ID: ${docRef.id}`);
      
      // Redirect after 2 seconds
      setTimeout(() => {
        navigate(`/trip/${docRef.id}`);
      }, 2000);
      
    } catch (error) {
      clearTimeout(timeout);
      console.error('❌ Error:', error);
      setResult(`❌ Error: ${error.message} (Code: ${error.code || 'Unknown'})`);
    } finally {
      clearTimeout(timeout);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-md mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Simple Trip Creator</h1>
        
        <div className="bg-white rounded-lg shadow p-6 mb-4">
          <p className="text-gray-600 mb-4">
            This is a simplified test to check if trip creation works.
          </p>
          
          <button
            onClick={createSimpleTrip}
            disabled={loading}
            className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? 'Creating...' : 'Create Test Trip'}
          </button>
          
          {loading && (
            <button
              onClick={cancelOperation}
              className="w-full mt-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
            >
              Cancel Operation
            </button>
          )}
        </div>

        {result && (
          <div className={`p-4 rounded-lg ${
            result.includes('✅') ? 'bg-green-50 border border-green-200' : 
            'bg-red-50 border border-red-200'
          }`}>
            <pre className="text-sm">{result}</pre>
          </div>
        )}

        <div className="mt-4 text-center">
          <button
            onClick={() => navigate('/dashboard')}
            className="text-blue-600 hover:text-blue-700 underline"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default SimpleCreateTrip;
